interface AnalyzeLoadingProps {
  size?: number;
  dur?: number;
}

const AnalyzeLoading = ({ size = 120, dur = 8 }: AnalyzeLoadingProps) => {
  const center = size / 1.8;

  const lensRadius = size * 0.085;
  const stroke = size * 0.025;

  const handleStart = lensRadius * 0.7;
  const handleEnd = lensRadius * 1.6;

  const move = size * 0.05;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform={`translate(${center} ${center})`}>
        <circle
          cx="0"
          cy="0"
          r={lensRadius}
          fill="none"
          stroke="#b50000"
          strokeWidth={stroke}
        />

        <line
          x1={handleStart}
          y1={handleStart}
          x2={handleEnd}
          y2={handleEnd}
          stroke="#b50000"
          strokeWidth={stroke}
          strokeLinecap="round"
        />

        <animateTransform
          attributeName="transform"
          type="translate"
          values={`
            ${center} ${center};
            ${center - move} ${center};
            ${center + move} ${center};
            ${center} ${center + move};
            ${center} ${center - move};
            ${center} ${center}
          `}
          dur={"8s"}
          repeatCount="indefinite"
        />

        <animateTransform
          attributeName="transform"
          type="scale"
          additive="sum"
          values="1;1.15;1;1.1;1"
          dur={"8s"}
          repeatCount="indefinite"
        />
      </g>
    </svg>
  );
};

export default AnalyzeLoading;
